<ng-template #content let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h4 class="modal-title" id="popup-title" i18n>Select Date Range</h4>
    <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <ngb-datepicker #dp (select)="onDateSelection($event)" [startDate]="{year: from.year, month: from.month}" [displayMonths]="2" [dayTemplate]="t">
    </ngb-datepicker>
    <ng-template #t let-date="date" let-focused="focused">
      <span class="custom-day"
            [class.focused]="focused"
            [class.range]="isRange(date)"
            [class.faded]="isHovered(date) || isInside(date)"
            (mouseenter)="hovered = date"
            (mouseleave)="hovered = null">
        {{ date.day }}
      </span>
    </ng-template>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-primary" [disabled]="!to && !from" (click)="c()" i18n>Apply Range</button>
  </div>
</ng-template>
